/// <reference types="vite/client" />
// Load uikit-tokens outside Tailwind's @import chain so Tailwind v4's
// tree-shaking doesn't strip the [data-theme=...] / [data-mode=...] variables
// our @theme bridge in styles/theme.css depends on.
import "@credit-acceptance/uikit-tokens";
import "./styles/index.css";
// Initialize i18next (react-i18next) before the app renders.
import "./i18n";

import { initializeOnDomReady } from "@credit-acceptance/common-frontend";

import App from "./App";

// page-hosting-api serves a bare <html> shell that doesn't carry the
// data-theme/data-mode attributes uikit-tokens scopes its variables under.
// Apply them at runtime so the design tokens resolve in production the same
// way they do in local dev (where index.html sets them).
document.documentElement.dataset.theme = "b2b2c-dawn";
document.documentElement.dataset.mode = "light";

if (import.meta.env.DEV) {
  const { worker } = await import("./mocks/browser");
  await worker.start({
    serviceWorker: { url: "/assets/mockServiceWorker.js" },
    onUnhandledRequest: "warn",
  });
}

initializeOnDomReady(App);
